import { Container } from '@volkswagen-onehub/components-core';
import styled from 'styled-components';

export const ViewsContainer = styled.div`
	display: grid;
`;

export const ViewWrapper = styled.div<{ $isActive: boolean }>`
	grid-area: 1 / 1;
	overflow: hidden;
	align-self: start;
	pointer-events: ${(props) => (props.$isActive ? 'auto' : 'none')};
	visibility: ${(props) => (props.$isActive ? 'visible' : 'hidden')};
`;

export const FilterTagsContainer = styled(Container)`
	overflow-x: auto; // sobreescribe el overflow-x de ViewWrapper
	-webkit-overflow-scrolling: touch;
	scrollbar-width: none;

	&::-webkit-scrollbar {
		display: none;
	}
`;

export const VehiclesGridWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	justify-items: center;
	gap: 16px 4px;

	@media (min-width: 960px) {
		grid-template-columns: repeat(5, 1fr);
	}
`;
